export const NAME = 'accessories';